<mat-card (click)="$event.stopPropagation()"
          (contextmenu)="showContextMenu($event)"
          (mousedown)="onMouseDown($event)"
          (mousemove)="onMouseMove()"
          (mouseup)="onMouseUp($event)"
          [class.nearly-overdue]="nearlyOverdue"
          [class.overdue]="overdue"
          [class.docked-left]="note.posX === 0"
          [class.docked-top]="note.posY === 49"
          [matRippleDisabled]="rippleDisabled"
          [style.background-color]="note.backgroundColor"
          [style.color]="note.foregroundColor" matRipple
          [cbHighlightColor]="note.backgroundColorGradient"
          [cbHighlightedItem]="note"
          data-cy="note">
  <mat-card-title *ngIf="note.header" class="flex-container" data-cy="note-header">
    {{ note.header }}
  </mat-card-title>
  <mat-card-content *ngIf="!note.code" data-cy="note-content">
    <div class="markdown" [innerHTML]="parsedMarkdown">
    </div>
  </mat-card-content>
  <mat-card-content *ngIf="note.code" data-cy="note-content">
    <pre *ngIf="note.content" class="note-code-content">
      <code class="dont-be-too-big" [highlight]="note.content" style="padding: 0; margin: -22px 0 -42px 0"></code>
    </pre>
  </mat-card-content>
  <mat-card-actions align="end">
    <button (click)="toggleCodeView($event, true)" (mousedown)="rippleDisabled=true"
            mat-icon-button [attr.aria-label]="'ENABLE_CODE_HIGHLIGHTING' | translate">
      <mat-icon *ngIf="!note.code">code</mat-icon>
      <mat-icon *ngIf="note.code">code_off</mat-icon>
    </button>

    <button (click)="edit($event, true)" (mousedown)="rippleDisabled=true"
            mat-icon-button [attr.aria-label]="'EDIT' | translate"
            data-cy="note-edit-btn">
      <mat-icon>edit</mat-icon>
    </button>

    <button (click)="delete($event)" (mousedown)="rippleDisabled=true"
            mat-icon-button [attr.aria-label]="'DELETE' | translate"
            data-cy="note-delete-btn">
      <mat-icon>delete</mat-icon>
    </button>

    <button (click)="showContextMenu($event)" (mousedown)="rippleDisabled=true"
            mat-icon-button [attr.aria-label]="'MORE' | translate"
            data-cy="note-more-btn">
      <mat-icon>more_vert</mat-icon>
    </button>
  </mat-card-actions>
  <mat-card-footer [style.margin-bottom.px]="-32"></mat-card-footer>
</mat-card>

<div [matMenuTriggerFor]="contextMenu"
     [style.left.px]="rightClickPosX"
     [style.top.px]="rightClickPosY"
     style="visibility: hidden; position: fixed">
</div>
<mat-menu #contextMenu="matMenu">
  <div [style.background]="note.backgroundColorGradient
            ? 'linear-gradient(to bottom, ' + note.backgroundColor + ', ' + note.backgroundColorGradient
            : note.backgroundColor"
       [style.color]="note.foregroundColor">
    <button *ngIf="!note.selected" (click)="select()" mat-menu-item
            [attr.aria-label]="'SELECT' | translate">
      <mat-icon>check</mat-icon>
      {{ 'SELECT' | translate }}
    </button>

    <button *ngIf="note.selected" (click)="select()" mat-menu-item
            [attr.aria-label]="'REMOVE_SELECTION' | translate">
      <mat-icon>close</mat-icon>
      {{ 'REMOVE_SELECTION' | translate }}
    </button>

    <ng-container *ngIf="!dataService.selectedItemsCount">
      <button (click)="edit($event)" mat-menu-item
              [attr.aria-label]="'EDIT' | translate">
        <mat-icon>edit</mat-icon>
        {{ 'EDIT' | translate }}
      </button>

      <button (click)="delete($event)" mat-menu-item
              [attr.aria-label]="'DELETE' | translate">
        <mat-icon>delete</mat-icon>
        {{ 'DELETE' | translate }}
      </button>
    </ng-container>

    <ng-container *ngIf="!dataService.selectedItemsCount">
      <button [matMenuTriggerFor]="movement" mat-menu-item
              [attr.aria-label]="'MOVE' | translate">
        <mat-icon>auto_awesome_motion</mat-icon>
        {{ 'MOVE' | translate }}
      </button>

      <ng-container *ngIf="dataService.tabs.length > 1">
        <button [matMenuTriggerFor]="tabs" mat-menu-item
                [attr.aria-label]="'SEND_TO_TAB' | translate">
          <mat-icon>tab</mat-icon>
          {{ 'SEND_TO_TAB' | translate }}
        </button>
      </ng-container>

      <ng-container *ngIf="dataService.getColorizedObjects(note).length > 1">
        <button [matMenuTriggerFor]="coloredItems" mat-menu-item
                [attr.aria-label]="'COPY_COLOR_FROM' | translate">
          <mat-icon>colorize</mat-icon>
          {{ 'COPY_COLOR_FROM' | translate }}
        </button>
      </ng-container>

      <ng-container *ngIf="dataService.itemsCount > 1">
        <button [matMenuTriggerFor]="connectableItems" mat-menu-item
                [attr.aria-label]="'CONNECT_TO' | translate">
          <mat-icon>cable</mat-icon>
          {{ 'CONNECT_TO' | translate }}
        </button>
      </ng-container>

      <ng-container *ngIf="dataService.getColorizedObjects(note).length === 1">
        <button (click)="copyColorFrom(dataService.getColorizedObjects(note)[0])" mat-menu-item
                [attr.aria-label]="'COPY_OTHER_COLOR' | translate">
          <mat-icon>colorize</mat-icon>
          {{ 'COPY_OTHER_COLOR' | translate }}
        </button>
      </ng-container>

      <button (click)="toggleCodeView($event)" (mousedown)="rippleDisabled=true"
              mat-menu-item [attr.aria-label]="'ENABLE_CODE_HIGHLIGHTING' | translate">
        <ng-container *ngIf="!note.code">
          <mat-icon>code</mat-icon>
          {{ 'ENABLE_CODE_HIGHLIGHTING' | translate }}
        </ng-container>
        <ng-container *ngIf="note.code">
          <mat-icon>code_off</mat-icon>
          {{ 'DISABLE_CODE_HIGHLIGHTING' | translate }}
        </ng-container>
      </button>

      <button (click)="copy()" mat-menu-item
              [attr.aria-label]="'COPY_VALUE' | translate">
        <mat-icon>content_copy</mat-icon>
        {{ 'COPY_VALUE' | translate }}
      </button>
    </ng-container>
  </div>
</mat-menu>

<mat-menu #movement="matMenu">
  <div [style.background]="note.backgroundColorGradient
            ? 'linear-gradient(to bottom, ' + note.backgroundColor + ', ' + note.backgroundColorGradient
            : note.backgroundColor"
       [style.color]="note.foregroundColor">
    <button (click)="dataService.bringToFront(note)" mat-menu-item
            [attr.aria-label]="'BRING_TO_FRONT' | translate">
      <mat-icon>flip_to_front</mat-icon>
      {{ 'BRING_TO_FRONT' | translate }}
    </button>

    <button (click)="dataService.bringForward(note)" mat-menu-item
            [attr.aria-label]="'BRING_FORWARD' | translate">
      <mat-icon>add_circle_outline</mat-icon>
      {{ 'BRING_FORWARD' | translate }}
    </button>

    <button (click)="dataService.sendBackward(note)" mat-menu-item
            [attr.aria-label]="'SEND_BACKWARD' | translate">
      <mat-icon>remove_circle_outline</mat-icon>
      {{ 'SEND_BACKWARD' | translate }}
    </button>

    <button (click)="dataService.flipToBack(note)" mat-menu-item
            [attr.aria-label]="'SEND_TO_BACK' | translate">
      <mat-icon>flip_to_back</mat-icon>
      {{ 'SEND_TO_BACK' | translate }}
    </button>
  </div>
</mat-menu>

<mat-menu #tabs="matMenu">
  <div [style.background]="note.backgroundColorGradient
            ? 'linear-gradient(to bottom, ' + note.backgroundColor + ', ' + note.backgroundColorGradient
            : note.backgroundColor"
       [style.color]="note.foregroundColor">
    <ng-container *ngFor="let tab of dataService.tabs">
      <button (click)="moveToTab(tab.index)" *ngIf="dataService.selectedTabIndex !== tab.index" mat-menu-item
              [attr.aria-label]="'SEND_TO_TAB' | translate">
        <mat-icon>arrow_forward</mat-icon>
        {{tab.label ? tab.label : '#Board ' + (tab.index + 1)}}
      </button>
    </ng-container>
  </div>
</mat-menu>

<mat-menu #coloredItems="matMenu">
  <ng-container *ngFor="let item of dataService.getColorizedObjects(note)">
    <button (click)="copyColorFrom(item)" *ngIf="note !== item" [style.background]="item.backgroundColorGradient
                ? 'linear-gradient(to bottom, ' + item.backgroundColor + ', ' + item.backgroundColorGradient
                : item.backgroundColor"
            [style.color]="item.foregroundColor"
            mat-menu-item [attr.aria-label]="'COPY_COLOR_FROM' | translate">
      <mat-icon>color_lens</mat-icon>
      <ng-container *ngIf="!item.backgroundColorGradient">
        {{item.backgroundColor}}
      </ng-container>
      <ng-container *ngIf="item.backgroundColorGradient">
        {{item.backgroundColor + ' → ' + item.backgroundColorGradient}}
      </ng-container>
    </button>
  </ng-container>
</mat-menu>

<mat-menu #connectableItems="matMenu">
  <ng-container *ngFor="let item of dataService.tab.notes">
    <button (click)="connectTo(item)" *ngIf="note !== item" [style.background]="item.backgroundColorGradient
                ? 'linear-gradient(to bottom, ' + item.backgroundColor + ', ' + item.backgroundColorGradient
                : item.backgroundColor"
            [style.color]="item.foregroundColor"
            mat-menu-item [attr.aria-label]="'CONNECT_TO' | translate">
      <mat-icon>{{note.connectedTo?.includes(item.id) ? 'close' : 'note'}}</mat-icon>
      {{DisplayValue.fromNote(item)}}
    </button>
  </ng-container>

  <ng-container *ngFor="let item of dataService.tab.noteLists">
    <button (click)="connectTo(item)" [style.background]="item.backgroundColorGradient
                ? 'linear-gradient(to bottom, ' + item.backgroundColor + ', ' + item.backgroundColorGradient
                : item.backgroundColor"
            [style.color]="item.foregroundColor"
            mat-menu-item [attr.aria-label]="'CONNECT_TO' | translate">
      <mat-icon>{{note.connectedTo?.includes(item.id) ? 'close' : 'sticky_note_2'}}</mat-icon>
      {{DisplayValue.fromNoteList(item)}}
    </button>
  </ng-container>

  <ng-container *ngFor="let item of dataService.tab.taskLists">
    <button (click)="connectTo(item)" [style.background]="item.backgroundColorGradient
                ? 'linear-gradient(to bottom, ' + item.backgroundColor + ', ' + item.backgroundColorGradient
                : item.backgroundColor"
            [style.color]="item.foregroundColor"
            mat-menu-item [attr.aria-label]="'CONNECT_TO' | translate">
      <mat-icon>{{note.connectedTo?.includes(item.id) ? 'close' : 'list'}}</mat-icon>
      {{DisplayValue.fromTaskList(item)}}
    </button>
  </ng-container>

  <ng-container *ngFor="let item of dataService.tab.images">
    <button (click)="connectTo(item)"
            mat-menu-item [attr.aria-label]="'CONNECT_TO' | translate"
            [style.background]="'var(--color-note)'">
      <mat-icon>{{note.connectedTo?.includes(item.id) ? 'close' : 'link'}}</mat-icon>
      {{DisplayValue.fromImage(item)}}
    </button>
  </ng-container>

  <button *ngIf="note.connectedTo" (click)="connectTo(undefined)"
          mat-menu-item [attr.aria-label]="'CONNECT_TO_NOTHING' | translate"
          [style.background]="'var(--color-note)'">
    <mat-icon>link_off</mat-icon>
    {{'CONNECT_TO_NOTHING' | translate}}
  </button>
</mat-menu>
